import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkCreateEntry } from '../types';

const onCreateEntry: IThunkCreateEntry = thunk(async (_, { entry, ...client }) => {
  await api.communityEngagement.createEntry(client, entry);
});

export default onCreateEntry;
